
@if(playerNumber) {

  @if (match.matchType === 'S') {
    <div class="deuce-ad-container" [style.background-color]="sideColor"></div>
  } @else if(match.discipline !== 'PICKLEBALL' && match.discipline !== 'BADMINTON' && match.sets?.length && match.matchType === 'D') {
    <div class="deuce-ad-container" [style.background-color]="sideColor">{{ courtSide }}</div>
  }

  <ion-item lines="none">
    <ion-text [style.font-weight]="900" [style.font-size.px]="platform.is('tablet') ? 22 : 18">
      @if(player) {
        {{ player?.last_name?.toUpperCase() }}<br *ngIf="!platform.is('tablet')" /><span *ngIf="platform.is('tablet')">, </span>{{ player?.first_name }}
      } @else {
        Player {{ sideNumber }}
      }
      <ion-text color="dark" [style.font-weight]="600">
        <br />{{ team?.abbreviation }} <span class="team-name">{{ match.sides[sideNumber - 1].note }}</span>
      </ion-text>
      @if (isServer()) {
        <div class="server">{{ match.score?.server?.serverNumber }}</div>
      }
    </ion-text>
    @if(defaultStatus){
        @if(defaultStatus?.itemValue?.sideNumber === sideNumber){
            <ion-text 
                slot="end" 
                [style.font-weight]="900" 
                [style.font-size.px]="platform.is('tablet') ? 22 : 18"
                [style.margin-right.px]="14">
                @if(defaultStatus?.itemValue?.infringementType === "CODE_VIOLATION"){
                    @if(defaultStatus?.itemValue?.penalty?.codeViolationType === "DEFAULT"){
                        DEF
                    }
                }
            </ion-text>
        }
        @if(defaultStatus?.itemValue?.sideNumber !== sideNumber){
            <ion-text 
                slot="end" 
                [style.font-weight]="900" 
                [style.font-size.px]="platform.is('tablet') ? 32 : 30" 
                [style.margin-right.px]="14">
                @if(defaultStatus?.itemValue?.infringementType === "CODE_VIOLATION"){
                    @if(defaultStatus?.itemValue?.penalty?.codeViolationType === "DEFAULT"){
                        <ion-icon class="icon win-checkmark" name="checkmark"></ion-icon>
                    }
                }
            </ion-text>
        }
    }
  </ion-item>
}